import React from 'react';
import { Connect, PropsFromRedux } from './TopLimitationContainer';
import { TopLimitationMessage } from './TopLimitationMessage';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

type Props = PropsFromRedux;

export class RawTopLimitation extends React.Component<Props> {
  showHiddenResults = () => {
    const {
      hiddenResults,
      totalHits,
      lastResponse,
      toggleTopResults,
    } = this.props;
    const resultsShown = totalHits - hiddenResults;
    doctrineAnalytics('Search ShowHiddenResults', {
      original_query_key: lastResponse,
      nb_results_shown: resultsShown,
      nb_results_hidden: hiddenResults,
    });
    toggleTopResults();
  };

  render() {
    const { showCutMessage, hiddenResults, totalHits } = this.props;

    return (
      showCutMessage && (
        <TopLimitationMessage
          hiddenResults={hiddenResults}
          totalHits={totalHits}
          showHiddenResults={this.showHiddenResults}
        />
      )
    );
  }
}

export const TopLimitation = Connect(RawTopLimitation);
